import { api } from "../../../config";

export const detectType = (mime, nameOrUrl) => {
  const name = nameOrUrl || "";
  const allowedMime = {
    image: ["image/jpeg", "image/png"],
    video: ["video/mp4", "video/quicktime", "video/x-msvideo", "video/x-matroska"],
    audio: ["audio/mpeg", "audio/wav", "audio/aac", "audio/mp4", "audio/ogg"],
    pdf: ["application/pdf"],
  };
  
  if (allowedMime.image.includes(mime)) return "image";
  if (allowedMime.video.includes(mime)) return "video";
  if (allowedMime.audio.includes(mime)) return "audio";
  if (allowedMime.pdf.includes(mime) || /\.pdf$/i.test(name)) return "pdf";
  if (/\.(jpe?g|png)$/i.test(name)) return "image";
  if (/\.(mp4|mov|avi|mkv)$/i.test(name)) return "video";
  if (/\.(mp3|wav|aac|m4a|ogg)$/i.test(name)) return "audio";
  return "file";
};

export const resolveMediaUrl = (maybePath) => {
  if (!maybePath) return maybePath;
  if (/^https?:\/\//i.test(maybePath) || maybePath.startsWith("blob:")) return maybePath;
  const base = process.env.REACT_APP_API_URL || process.env.REACT_APP_SOCKET_URL || api.API_URL || "";
  const cleanBase = String(base).replace(/\/+$/, "");
  const cleanPath = String(maybePath).replace(/^\/+/, "");
  return `${cleanBase}/${cleanPath}`;
};

export const getFilenameFromUrl = (url) => {
  try {
    const u = new URL(url, window.location.origin);
    const name = u.pathname.split("/").pop();
    return name || "download";
  } catch {
    return "download";
  }
};

export const downloadFile = async (url, filename = "download") => {
  try {
    const response = await fetch(url, { credentials: 'include' });
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  } catch (e) {
    // Fallback to direct link if fetch blocked
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
};

export const calculateMemberCount = (chatData) => {
  if (chatData.counts?.membersCount) return chatData.counts.membersCount;
  const memberIds = new Set();
  if (chatData.groupAdmin?._id) memberIds.add(chatData.groupAdmin._id);
  if (Array.isArray(chatData.superAdmins)) {
    chatData.superAdmins.forEach(admin => {
      if (admin?._id) memberIds.add(admin._id);
    });
  }
  if (Array.isArray(chatData.members)) {
    chatData.members.forEach(member => {
      if (member?._id) memberIds.add(member._id);
    });
  }
  return memberIds.size || 0;
};

// utils/dateFormatter.js
export const formatLastMessageTime = (timestamp) => {
  if (!timestamp) return '';
  
  const messageDate = new Date(timestamp);
  const now = new Date();
  const diffInMs = now - messageDate;
  const diffInHours = diffInMs / (1000 * 60 * 60);
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  // Within 24 hours - show time
  if (diffInHours < 24) {
    return messageDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }
  // Between 24-48 hours - show "Yesterday"
  else if (diffInDays < 2) {
    return 'Yesterday';
  }
  // More than 48 hours - show date and month
  else {
    return messageDate.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short'
    });
  }
};